import BaseModal from '../components/BaseModal/index.js';

/**
 * Initialize ingredients widget modal functionality
 */
function ingredients() {
    const triggers      = document.querySelectorAll('[data-ingredients-trigger]');
    const modalSettings = {
        openTrigger         : 'data-basemodal-trigger',
        closeTrigger        : 'data-basemodal-close',
        openClass           : 'is-open',
        allowNested         : true,
        position            : 'center',
        theme               : 'light',
        animation           : 'slideUp',
        size                : 'ingredients',
        hapticFeedback      : true,
        awaitOpenAnimation  : true,
        awaitCloseAnimation : true
    };
    triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();

            const modalId = trigger.dataset.ingredientsModalId;
            const modal   = document.getElementById(modalId);

            if (!modal) {
                return;
            }

            // Get data from trigger
            const image       = trigger.dataset.ingredientsImage || '';
            const modalImageDataRaw = trigger.dataset.ingredientsModalImage || '';
            const title       = trigger.dataset.ingredientsTitle || '';
            const description = trigger.dataset.ingredientsDescription || '';
            const link        = trigger.dataset.ingredientsLink || '';

            // Fill modal with data
            const modalImageWrapper = modal.querySelector('.ingredients-modal__image-wrapper');
            const modalTitle       = modal.querySelector('.ingredients-modal__title');
            const modalDescription = modal.querySelector('.ingredients-modal__description');
            const modalLink        = modal.querySelector('.ingredients-modal__link');

            if (modalImageWrapper) {
                modalImageWrapper.innerHTML = '';
                if (modalImageDataRaw) {
                    try {
                        const modalImageData = JSON.parse(modalImageDataRaw);
                        const picture = document.createElement('picture');
                        const source = document.createElement('source');
                        source.srcset = `${modalImageData.webp_1x} 1x, ${modalImageData.webp_2x} 1.3x`;
                        source.type = 'image/webp';
                        const img = document.createElement('img');
                        img.alt = title;
                        img.loading = 'lazy';
                        img.width = 618;
                        img.height = 210;
                        img.src = modalImageData.original_1x;
                        picture.appendChild(source);
                        picture.appendChild(img);
                        modalImageWrapper.appendChild(picture);
                    } catch {
                        // Fallback to plain image
                        const img = document.createElement('img');
                        img.className = 'ingredients-modal__image';
                        img.src = image;
                        img.alt = title;
                        modalImageWrapper.appendChild(img);
                    }
                }
            }

            if (modalTitle) {
                modalTitle.textContent = title;
            }

            if (modalDescription) {
                modalDescription.textContent = description;
            }

            if (modalLink) {
                modalLink.href          = link;
                modalLink.style.display = link ? 'inline-flex' : 'none';
            }

            // Open modal using BaseModal
            BaseModal.show(modalId, modalSettings);
        });
    });
}

export { ingredients };
